import { createTransform } from 'redux-persist';
import Immutable from 'seamless-immutable';

// optionally convert this object into a JS object if it is Immutable
export const fromImmutable = (state) => (isImmutable(state) ? Immutable.asMutable(state) : state);

// convert this JS object into an Immutable object
export const toImmutable = (state) => (isImmutable(state) ? state : Immutable(state));

// // the transform interface that redux-persist is expecting
// export default {
//   out: state => {
//     //console.log(state)
//     // --- HACKZORZ ---
//     // Attach a empty-ass function to the object called `mergeDeep`.
//     // This tricks redux-persist into just placing our Immutable object into the state tree
//     // instead of trying to convert it to a POJO
//     // https://github.com/rt2zz/redux-persist/blob/master/src/autoRehydrate.js#L55
//     //
//     // Another equal terrifying option would be to try to pass their other check
//     // which is lodash isPlainObject.
//     // --- END HACKZORZ ---
//     state.mergeDeep = a => a;
//     //console.log(toImmutable(state));
//     return toImmutable(state);
//   },
//   in: raw => {
//     console.log({ storing: raw })
//     return fromImmutable(raw);
//   }
// };

export const immutableTransform = createTransform(
  // transform state coming from redux on its way to being serialized and stored
  (state) => fromImmutable(state),
  // transform state coming from storage, on its way to be rehydrated into redux
  (state) => toImmutable(state)
);

export const immutableReconciler = (inboundState, originalState, reducedState, { debug, mergeDeep = false }) => {
  let newState = { ...reducedState };
  // only rehydrate if inboundState exists and is an object
  if (inboundState && typeof inboundState === 'object') {
    Object.keys(inboundState).forEach((key) => {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (process.env.NODE_ENV !== 'production' && debug) {
          // eslint-disable-next-line no-console
          console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        }

        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = { ...newState[key], ...inboundState[key] };
        return;
      } else if (reducedState[key] && isImmutable(reducedState[key])) {
        // if this is a seamless-immutable state slice, use its own merge function
        newState[key] = newState[key].merge(inboundState[key], {
          deep: mergeDeep,
        });
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (process.env.NODE_ENV !== 'production' && debug && inboundState && typeof inboundState === 'object') {
    // eslint-disable-next-line no-console
    console.log(`redux-persist/stateReconciler: rehydrated keys '${Object.keys(inboundState).join(', ')}'`);
  }

  return newState;
};

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && typeof o === 'object' && !isImmutable(o);
}

function isImmutable(obj) {
  return Immutable.isImmutable(obj);
}
